<template>
  <div>
    <div class="card border-light">
      <div class="card-header border-light bg-light navbar">
        <div class="pt-2 w-25" id="canvas-title">
          <i class="fas fa-chart-area me-1"></i>
          <span class="h5">{{ meter.mac_alias ?? meter.bx_mac }}</span>
        </div>
        <div class="set-time-and-circuits">
          <label class="pt-1">時間： </label>
          <input type="date" v-model="set_date" :min="firstDataCreatedAt" :max="latestDataCreatedAt" />
          <select-circuits class="ml-3"></select-circuits>
        </div>
      </div>
      <div class="card-body bg-light pt-0 pb-0">
        <energy-usage-chart v-if="false && mountComponent && time_format === 'day'"></energy-usage-chart>
        <div id="do-canvas" v-for="(circuit, index) in meter.bx_circuits" :key="index"
          v-if="mountComponent && request_date && isShow(circuit.id)">
          <each-channel-canvas :id="`channel-chart-${circuit.id}`" :circuit-data="circuit"
            ref="eachChannels"></each-channel-canvas>
          <div :id="`error-msg${circuit.id}`" class="display-1 text-center"></div>
        </div>
      </div>
      <div class="card-footer border-light bg-light d-flex flex-row-reverse">
        <button v-if="time_format !== 'day'" class="btn btn-outline-info" @click="canvasExport()">
          匯出表單
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SelectCircuits from "./buttons/SelectCircuits.vue";
import EnergyUsageChart from "@components/EnergyUsageChart.vue";
import EachChannelCanvas from "@components/EachChannelCanvas.vue";
import { axiosMixins } from './mixins/axiosErrorMessage';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";

export default {
  components: { SelectCircuits, EnergyUsageChart, EachChannelCanvas },
  mixins: [axiosMixins],
  data() {
    return {
      is_dev: false,
      set_date: '',
      selected_circuit_ids: [],
      mountComponent: false,
    };
  },
  mounted() {
    process.env.NODE_ENV !== "production"
      ? (this.is_dev = true)
      : (this.is_dev = false);
  },
  computed: {
    meter() {
      return this.$store.getters.selectedMeter;
    },
    time_format() {
      return this.$store.getters.historicalDataTimeFormat;
    },
    selectedCircuitIds() {
      return this.$store.getters.selectedCircuitIds;
    },
    firstDataCreatedAt() {
      return this.$store.getters.bxCreationTimes.firstCreateAt;
    },
    latestDataCreatedAt() {
      return this.$store.getters.bxCreationTimes.latestCreateAt;
    },
    request_date() {
      return this.$store.getters.requestDate;
    },
  },
  watch: {
    request_date() {
      this.set_date = this.$store.getters.requestDate;
      this.getCircuitsData();
    },
    time_format() {
      this.getCircuitsData();
    },
    set_date() {
      this.$store.commit("setRequestDate", this.set_date);
    }
  },
  methods: {
    isShow(id) {
      return this.selectedCircuitIds.includes(id);
    },
    async getCircuitsData() {
      this.mountComponent = false;
      const bxCircuits = this.meter.bx_circuits;
      const fetchDataPromises = bxCircuits.map(async (circuit) => {
        try {
          const getBxLog = {
            year: this.request_date.split("-")[0],
            month: this.request_date.split("-")[1],
            day: this.request_date.split("-")[2],
            circuit_id: circuit.id,
            mac: this.meter.bx_mac,
          };
          const response = await axios.post(`${base_url}/api/bx/log/${this.time_format}`, getBxLog);
          circuit["electricity_data"] = response.data.electricity_data;
          circuit["cumulative_data"] = response.data.cumulative_data;
        } catch (error) { this.axiosMessage(error); }
      });
      try {
        await Promise.all(fetchDataPromises);
        this.mountComponent = true;
      } catch (error) {
        console.error(error);
      }
    },
    async canvasExport() {
      const bx_circuits = this.meter.bx_circuits;
      let timeDuration = [];
      for (let i = 0; i < bx_circuits[0].cumulative_data.length; i++) {
        timeDuration.push(bx_circuits[0].cumulative_data[i].time.split(" ")[0]);
      }

      const pdf = new jsPDF();
      const timeDurationString = timeDuration[0] + " - " + timeDuration[timeDuration.length - 1];
      pdf.text(timeDurationString, 160, 10);
      pdf.line(10, 15, 200, 15);

      try {
        const canvas_title = await html2canvas(this.$el.querySelector("#canvas-title"));
        let data_canvas = [];
        for (let i = 0; i < this.selected_circuit_ids.length; i++) {
          data_canvas[i] = await html2canvas(this.$el.querySelector(`#channel-chart-${this.selected_circuit_ids[i]}`));
        }

        pdf.addImage(canvas_title.toDataURL("image/png"), "PNG", 10, 4, 95, 8);
        for (let i = 0; i < data_canvas.length; i++) {
          pdf.addImage(data_canvas[i].toDataURL("image/png"), "PNG", 10, 20 + (i * 80), 190, 62);
        }
        pdf.save(`${this.meter.mac_alias} ${timeDurationString}.pdf`);

      } catch (error) {
        console.error("html2canvas 出現錯誤:", error);
      }
    },
    setFontStyle() {
      var callAddFont = function () {
        this.addFileToVFS('NotoSansTC-normal.ttf', fontStyle());
        this.addFont('NotoSansTC-normal.ttf', 'NotoSansTC', 'normal');
      };
      jsPDF.API.events.push(['addFonts', callAddFont])
    }
  },
};
</script>

<style>
.set-time-and-circuits {
  display: block;
}

@media (min-width: 768px) {
  .set-time-and-circuits {
    display: flex;
  }
}

#do-canvas {
  padding: 0;
}

@media (min-width: 768px) {
  #do-canvas {
    padding: 1.25rem;
  }
}
</style>
